// This file was generated by lezer-generator. You probably shouldn't edit it.
export const Number = 1,
  Duration = 2,
  String = 3,
  IncompleteString = 4,
  ExistsOperator = 5,
  Filter = 6,
  FilterGroup = 7,
  OpeningBracket = 8,
  FilterStatement = 9,
  FilterKey = 10,
  Identifier = 11,
  ComparisonOperator = 12,
  InvalidComparisonOperator = 13,
  FilterSimpleValue = 14,
  PositionOperator = 15,
  Boolean = 16,
  InclusionOperator = 17,
  FilterIncludesValue = 18,
  List = 19,
  ClosingBracket = 20,
  ListValue = 21,
  InvalidInclusionValue = 22,
  LogicalOperator = 23;
